module.exports = __webpack_public_path__ + "static/media/md-eye.26d4b395.svg";